var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon24PxCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2409_97387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4847 16.6746C10.9944 17.1649 10.7493 17.41 10.4681 17.4982C10.2208 17.5757 9.95515 17.5711 9.71075 17.485C9.43277 17.3872 9.19626 17.1337 8.72323 16.6267L4.46258 12.0603C4.17932 11.7567 4.19654 11.2807 4.50101 10.9984C4.80408 10.7174 5.27737 10.7344 5.55944 11.0365L10.1192 15.9201L18.9392 7.10007C19.2319 6.80736 19.7065 6.80736 19.9992 7.10007C20.2919 7.39278 20.2919 7.86736 19.9992 8.16007L11.4847 16.6746Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2409_97387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PxCheck);
export default __webpack_public_path__ + "static/media/icon_24px_check.590b5325da7e8cd0bbdd666ab34ed265.svg";
export { ForwardRef as ReactComponent };